export class Rule {
    public id: number;

    constructor(
        public criterioId: number | null,
        public tipoReglaId: number | null,
        public prioridad: number | null,
        public param1: number | null,
        public param2: number | null,
        public tareaId: number | null,
        public dias: number | null,
    ) { }
}

export class RuleType {
    tipoReglaId: number;
    regla: string;
    parametro: string;
    tipoParametro: string;
    parametro2: string;
    tipoParametro2: string;
}

export class Criteria {
    criterioId: number;

    constructor(
        public nombre: string
    ) { }
}